import { z } from 'zod';

export const InvestmentExperienceValues = ['novice', 'intermediate', 'expert'] as const;

export type InvestmentExperience = (typeof InvestmentExperienceValues)[number];

export const ZodInvestmentExperience = z.enum(InvestmentExperienceValues);
